import React from "react";

const PrivacyPolicyOfBook = () => {
  return (
    <div className="w-full">
      {/* Terms Content */}
      <div className=" w-full ">
        <p className="text-start font-['Roboto'] text-black text-lg">
          The website{" "}
          <a
            href="https://www.iskconvijayawada.org"
            className="text-blue-500 no-underline"
          >
            www.iskconvijayawada.org
          </a>{" "}
          is fully owned by International Society of Krishna Consciousness
          (ISKCON), Hare Krishna Land, vijayawada, Skew Bridge, Krishna Lanka, Vijayawada - 520013
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We know that you, being the user of the Website, care how information
          about you is used and shared and we appreciate your trust in us to do
          that carefully and sensibly. This page informs you of our policies
          regarding the collection, use, storage, disclosure and transfer of the
          personal information we receive from the users of www.iskconvijayawada.org
          ("Website"). By visiting the Website, you are accepting and consenting
          to the practices described in this Privacy Policy.
        </p>
        <h2 className="text-xl font-bold text-[#c61d21]">
          Controllers of Personal Information
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Any personal information provided to or gathered by ISKCON vijayawada
          in accordance with this Privacy Policy will be stored and controlled
          by ISKCON vijayawada .
        </p>
      </div>

      {/* What is personal information*/}
      <h2 className="text-2xl font-bold text-[#c61d21]">
        What personal information about users does ISKCON Vijaywada gather?
      </h2>
      <div>
        <p className="text-start font-['Roboto'] text-black text-lg">
          The information we learn from the Website users helps us personalise
          and continually improve your experience of using the Website. We use
          your information for various purposes including to communicate with
          you about your brand and products, gather information about your brand
          and products, update our records, evaluate your requests to purchase
          products from you and sell such products, respond to your requests,
          and for other purposes specified in the Privacy Policy. If you submit
          this information in relation to a potential job opportunity advertised
          on the Website, we may use this information to communicate with you
          for the proposed opportunity and/or to evaluate your candidature and
          suitability for the proposed job opportunity.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We also use this information to improve our Website and offerings,
          provide new offerings, prevent or detect fraud or abuses of our
          Website and enable third parties to carry out certain applicable
          functions on our behalf.
        </p>
      </div>
      {/* Types of information */}
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Here are the types of information we gather.
        </h2>
        <h3 className="text-2xl font-bold text-[#c61d21]">
          {" "}
          Information you give us
        </h3>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We receive and store any information you enter on our Website or give
          us in any other way. Examples of information that you give us and we
          collect include your contact information like name, email address,
          postal address, phone number, information provided by you in
          connection with a job opportunity or otherwise while contacting us.
          You can choose not to provide certain information, however, that may
          affect our capability to evaluate business opportunities with you or
          your job application or otherwise, and to provide you with information
          about ISKCON vijayawada .
        </p>

        <h3 className="text-2xl font-bold text-[#c61d21]">
          {" "}
          Information from other sources
        </h3>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We might receive information about you from other sources and, where
          applicable, add it to your account information.
          <br />
          <br />
          By using or continuing to use the Website, you agree to our use of
          your information (including sensitive personal information, if any) in
          accordance with this Privacy Policy, as may be amended from time to
          time by ISKCON vijayawada  in its discretion. You also agree and
          consent to us collecting, storing, processing, transferring and
          sharing information (including sensitive personal information, if any)
          related to you with third parties or service providers for the
          purposes as set out in this Privacy Policy.
          <br />
          <br />
          We may be required to share the aforesaid information with government
          authorities and agencies for various purposes including verification
          of identity or for prevention, detection, investigation including
          cyber incidents, prosecution and punishment of offences. You agree and
          consent for ISKCON vijayawada  to disclose your information, if
          required, for the above mentioned purposes, or/and under the
          applicable laws or pursuant to an order of a judicial / government
          authority.
        </p>

        <h2 className="text-xl font-bold text-[#c61d21]">
          Sensitive personal data or information
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We generally do not collect any sensitive personal data or
          information. Sensitive personal data or information includes your
          passwords, financial information (such as bank account and credit card
          details), sexual orientation, medical history, biometric information
          and such other information as may be classified as sensitive personal
          data or information under law. We urge all users using the Website not
          to share any sensitive personal data or information. If you
          voluntarily submit any sensitive personal data or information on the
          Website, you do so at your own risk and we assume no liability or
          responsibility for consequences of your submission. Where we
          specifically require you to provide sensitive personal data or
          information, such information will be processed in accordance with
          this Privacy Policy.
        </p>




        <h2 className="text-2xl font-bold text-[#c61d21]">
          Updates:
        </h2>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            Your usernames, passwords, email addresses and other security-related information used by you in relation to our Services.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            Send confirmations either via SMS or Whatsapp or any other messaging service.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            We send promotional messages to our customers.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            Send verification message(s) & Promotional messages or email(s).
          </li>
        </ol>




        <h2 className="text-2xl font-bold text-[#c61d21]">
          What about cookies?
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Cookies are alphanumeric identifiers that we transfer to your
          computer's hard drive through your web browser to enable our systems
          to recognise your browser and to provide certain features on the
          Website. The Help menu on the menu bar of most browsers will tell you
          how to prevent your browser from accepting new cookies, how to have
          the browser notify you when you receive a new cookie and how to
          disable cookies altogether. Additionally, you can disable or delete
          similar data used by browser add-ons, such as Flash cookies, by
          changing the add-on's settings or visiting the website of its
          manufacturer. However, because cookies allow you to take advantage of
          some of the Website's essential features, we recommend that you leave
          them turned on. For instance, if you block or otherwise reject our
          cookies, you will not be able to view the complete Website. If you do
          leave cookies turned on, be sure to sign off when you finish using a
          shared computer.
        </p>

        <h2 className="text-2xl font-bold text-[#c61d21]">
          Does cloudtail share the information it receives?
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Information about our users is an important part of our business and
          we are not in the business of selling it to others. ISKCON vijayawada
          shares user information only as described under this Privacy Policy
          and with the parent company / affiliates / subsidiaries/associates of
          ISKCON vijayawada  and that are either subject to this Privacy Policy
          or follow practices at least as protective as those described in this
          Privacy Policy.
        </p>

        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            <strong>Affiliated Businesses We Do Not Control:</strong>
            We work closely with associated businesses. We may share your
            information with such businesses on a need-to-know basis and require
            them to follow practices at least as protective as those described
            in this Privacy Policy.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            <strong>Third Party Service Providers: </strong>We employ other
            companies and individuals to perform functions on our behalf. These
            service providers may have access to your personal information
            needed to perform their functions, but may not use it for other
            purposes. Further, they will process the personal information in
            accordance with this Privacy Policy and as permitted by the
            applicable law.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            <strong>With your consent:</strong> Other than as set out above, you
            will receive notice when information about you might go to third
            parties and you will have an opportunity to choose not to share the
            information.
          </li>
        </ol>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Whenever we transfer personal information to countries outside India
          in the course of sharing information as set out above, we will ensure
          that the information is transferred in accordance with this Privacy
          Policy and as permitted by the applicable laws including but not
          limited to Information Technology Act, 2000 and the rules framed there
          under.
        </p>
      </div>

      {/* How Secure Information */}
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          How secure is information about me?
        </h2>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            We maintain physical, electronic and procedural safeguards in
            connection with the collection, storage and disclosure of personal
            information (including sensitive personal information, if
            collected). Our security procedures may require that we occasionally
            request proof of identity before we disclose personal information to
            you.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            It is important for you to protect against unauthorised access to
            your password and to your computer. Be sure to sign off when you
            finish using a shared computer.
          </li>
        </ol>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          <h2 className="text-2xl font-bold text-[#c61d21]">
            What about third-party advertisers and links to other web sites?
          </h2>
        </h2>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          What information can I access?
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          <strong>ISKCON Vijayawada</strong> gives you access to a broad range
          of information about your account (where applicable)and your
          interactions with ISKCON vijayawada  for the limited purpose of
          viewing and, in certain cases, updating that information. This list
          will change as our Website evolves.
        </p>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          What choices do I have?
        </h2>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            As discussed above, you can always choose not to provide
            information, even though it might be needed to take advantage of the
            Website features such as, an enquiry to be addressed by{" "}
            <strong>ISKCON Vijayawada </strong> team, etc.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            When you share information we retain the information in our records.
          </li>
          <li className="text-lg [&::marker]:text-2xl [&::marker]:text-[#c61d21]">
            If you do not want to receive e-mail or other mail from us, please
            adjust your communication preferences accordingly. If you do not
            want to receive Conditions of Use and other legal notices from us,
            such as this Privacy Policy, those notices will still govern your
            use of the Website, and it is your responsibility to review them for
            changes.
          </li>
        </ol>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Policy and revisions
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          If you have any concern about privacy or grievances at ISKCON vijayawada
          , please write to us on info@iskcon.com with a thorough
          description and we will try to resolve the issue for you.
          <br />
          <br />
          Our business changes constantly and our Privacy Policy and the
          Conditions of Use will change also. We may e-mail periodic reminders/
          updates of our policies and conditions, unless you have instructed us
          not to, but you should check our Website frequently to see recent
          changes.
          <br />
          <br />
          Unless stated otherwise, our current Privacy Policy applies to all
          information that we have about you and your account. We stand behind
          the promises we make and will never materially change our policies and
          practices to make them less protective of user information collected
          in the past without the consent of affected users.
        </p>
      </div>

    </div>
  );
};

export default PrivacyPolicyOfBook;
